import Store from '../Store'
import { actions, apis } from '../constants'

export default function (ajax) {
  let store = new Store({
    state: {
      numberOperate: [
        { name: ">", value: "gt" },
        { name: "=", value: "equal" },
        { name: "<", value: "lt" },
        { name: ">=", value: "ge" },
        { name: "<=", value: "le" },
        { name: "≠", value: "not equal" }
      ],
      stringBusinessOperate: [
        { name: "是", value: "equal" },
        { name: "不是", value: "not equal" },
      ],
      stringOperate: [
        { name: "是", value: "equal" },
        { name: "包含", value: "contains" },
        { name: "不是", value: "not equal" },
        { name: "不包含", value: "not contains" },
        { name: "开头是", value: "begin with" },
        { name: "结尾是", value: "end with" },
        { name: "开头不是", value: "not begin with" },
        { name: "结尾不是", value: "not end with" },
        { name: "是空值", value: "is null" },
        { name: "不是空值", value: "is not null" }
      ],
      strOperateMap: {
        equal: "是",
        contains: "包含",
        "not equal": "不是",
        "not contains": "不包含",
        "begin with": "开头是",
        "end with": "结尾是",
        "not begin with": "开头不是",
        "not end with": "结尾不是",
        "is null": "是空值",
        "is not null": "不是空值"
      },
      dateOperate: [
        { name: "最近", value: "relative" },
        { name: "固定时段", value: "absolute" }
      ]
    },
    mutations: {},
    // ajax中的toProxy参数目前只在视屏服务中有效
    actions: {
      [actions.biz.common.queryEsData](
        context,
        param = {
          appId: "",
          platform: "",
          dimensionSub: "",
          limit: 10000,
          attr: 0,
          v: "",
          model: ""
        }
      ) {
        return new Promise((resolve, reject) => {
          let params = {
            app_id: param.appId,
            platform: param.platform,
            dimension_sub: param.dimensionSub,
            limit: param.limit,
            attr: param.attr,
            v: param.v
          };
          if (param.model) {
            params.model = param.model;
          }
          ajax({
            url: apis.common.queryEsData,
            toProxy: true,
            unique: true,
            delay: 300,
            data: params
          })
            .then(res => {
              resolve(res.sources || []);
            })
            .catch(err => {
              reject(err);
            });
        });
      }
    }
  });
  return store
}
